/**
 * @generated SignedSource<<21c574e98897a3369ac79da3e6c24dd4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ReferencesEditor_ReferencesQuery$variables = Record<PropertyKey, never>;
export type ReferencesEditor_ReferencesQuery$data = {
  readonly currentUser: {
    readonly name: string | null | undefined;
    readonly references: ReadonlyArray<{
      readonly email: string | null | undefined;
      readonly id: string;
      readonly name: string | null | undefined;
    }> | null | undefined;
  } | null | undefined;
};
export type ReferencesEditor_ReferencesQuery = {
  response: ReferencesEditor_ReferencesQuery$data;
  variables: ReferencesEditor_ReferencesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "status",
      "value": "pending"
    }
  ],
  "concreteType": "Reference",
  "kind": "LinkedField",
  "name": "references",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    }
  ],
  "storageKey": "references(status:\"pending\")"
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReferencesEditor_ReferencesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ReferencesEditor_ReferencesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v2/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "72fbd96d2c37e5796392373cafef2f44",
    "id": null,
    "metadata": {},
    "name": "ReferencesEditor_ReferencesQuery",
    "operationKind": "query",
    "text": "query ReferencesEditor_ReferencesQuery {\n  currentUser {\n    name\n    references(status: pending) {\n      id\n      name\n      email\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "984eaa051c9037d113614e43303f7ac0";

export default node;
